'use es6';

import LoginFailureHandlerFactory from '../lib/LoginFailureHandlerFactory';
import GoogleLoginDao from '../data/GoogleLoginDao';
import googleLoginNonce from '../lib/googleLoginNonce';
const googleLoginDao = new GoogleLoginDao();
export const loginWithGoogleAndRedirect = (credentials, handleError, history) => {
  const triggerReset = () => handleError('LOGIN_UNAVAILABLE');

  googleLoginDao.initialize(credentials).then(googleLoginNonce.storeAndRedirect).catch(LoginFailureHandlerFactory.createRavenReporter('Google initialization failed', triggerReset, history.push));
};